<template lang="pug">
.star-generator.d-flex
  v-icon(v-for='(fill, fillIndex) in star' :key='`${star}-star-fill-${fillIndex}`' color='warning500' :size='size' :class="classes") $yzi-star-01-fill
  v-icon(v-for='(blank, blankIndex) in totalStar - star' :key='`${totalStar - star}-star-blank-${blankIndex}`' color='neutral400' :size='size' :class="classes") $yzi-star-01
</template>

<script>

export default {
  name: 'StarGenerator',
  props: {
    totalStar: {
      type: Number,
      default: 5
    },
    star: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 20,
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
</style>
